module.exports = __webpack_public_path__ + "static/media/no-live-image.5f81223c.png";